const CHARGE_ITEM_MENU_PATH = '/basicdata/hospital/charge-item'
const OPERATIVE_ITEM_MENU_PATH = '/basicdata/operative-item'
const DENTAL_SERVICE_ITEM_MENU_PATH = '/basicdata/dental-service-item'
const LABORATORY_ITEM_MENU_PATH = '/basicdata/laboratory-item'

const normalizeMenuPath = (url = '') => String(url).split('?')[0].replace(/\/$/, '')
const normalizeMenuChildren = (items = []) => {
  if (Array.isArray(items)) return items
  if (items && typeof items === 'object') return Object.values(items)
  return []
}

const containsMenuPath = (items = [], path) =>
  normalizeMenuChildren(items).some(
    (item) => normalizeMenuPath(item?.url) === path || containsMenuPath(item?.children, path)
  )

export const addOperativeItemMenu = (items = []) => {
  if (!Array.isArray(items) || containsMenuPath(items, OPERATIVE_ITEM_MENU_PATH)) return items

  let inserted = false
  const addAfterChargeItem = (menuItems = []) =>
    normalizeMenuChildren(menuItems).reduce((result, item) => {
      if (!item) return result

      const nextItem = item.children
        ? { ...item, children: addAfterChargeItem(item.children) }
        : item
      result.push(nextItem)

      if (!inserted && normalizeMenuPath(item.url) === CHARGE_ITEM_MENU_PATH) {
        result.push({
          access: item.access || [],
          groupMenuId: item.groupMenuId,
          icon: 'feather icon-scissors',
          id: `${item.groupMenuId || 'basicdata'}-operative-item`,
          linkType: 'router',
          seq: Number(item.seq || 0) + 0.01,
          title: 'Operative Item',
          type: 'item',
          url: OPERATIVE_ITEM_MENU_PATH,
        })
        inserted = true
      }

      return result
    }, [])

  return addAfterChargeItem(items)
}

export const addLaboratoryItemMenu = (items = []) => {
  if (!Array.isArray(items) || containsMenuPath(items, LABORATORY_ITEM_MENU_PATH)) return items

  const insertAfterPath = containsMenuPath(items, DENTAL_SERVICE_ITEM_MENU_PATH)
    ? DENTAL_SERVICE_ITEM_MENU_PATH
    : containsMenuPath(items, OPERATIVE_ITEM_MENU_PATH)
      ? OPERATIVE_ITEM_MENU_PATH
      : CHARGE_ITEM_MENU_PATH
  let inserted = false
  const addAfterServiceItem = (menuItems = []) =>
    normalizeMenuChildren(menuItems).reduce((result, item) => {
      if (!item) return result

      const nextItem = item.children
        ? { ...item, children: addAfterServiceItem(item.children) }
        : item
      result.push(nextItem)

      if (!inserted && normalizeMenuPath(item.url) === insertAfterPath) {
        result.push({
          access: item.access || [],
          groupMenuId: item.groupMenuId,
          icon: 'feather icon-activity',
          id: `${item.groupMenuId || 'basicdata'}-laboratory-item`,
          linkType: 'router',
          seq: Number(item.seq || 0) + 0.01,
          title: 'Laboratory Item',
          type: 'item',
          url: LABORATORY_ITEM_MENU_PATH,
        })
        inserted = true
      }

      return result
    }, [])

  return addAfterServiceItem(items)
}

export const addDentalServiceItemMenu = (items = []) => {
  if (!Array.isArray(items) || containsMenuPath(items, DENTAL_SERVICE_ITEM_MENU_PATH)) return items

  const insertAfterPath = containsMenuPath(items, OPERATIVE_ITEM_MENU_PATH)
    ? OPERATIVE_ITEM_MENU_PATH
    : CHARGE_ITEM_MENU_PATH
  let inserted = false
  const addAfterServiceItem = (menuItems = []) =>
    normalizeMenuChildren(menuItems).reduce((result, item) => {
      if (!item) return result

      const nextItem = item.children
        ? { ...item, children: addAfterServiceItem(item.children) }
        : item
      result.push(nextItem)

      if (!inserted && normalizeMenuPath(item.url) === insertAfterPath) {
        result.push({
          access: item.access || [],
          groupMenuId: item.groupMenuId,
          icon: 'feather icon-smile',
          id: `${item.groupMenuId || 'basicdata'}-dental-service-item`,
          linkType: 'router',
          seq: Number(item.seq || 0) + 0.01,
          title: 'Dental Service Item',
          type: 'item',
          url: DENTAL_SERVICE_ITEM_MENU_PATH,
        })
        inserted = true
      }

      return result
    }, [])

  return addAfterServiceItem(items)
}
